<template>
    <div class="content-wrapper">
        <app-page-top-section :title="$t('faqs')" >
            <app-default-button
                    v-if="$can('create_faqs')"
                    :title="$addLabel('faqs')"
                    @click="openAddModal"
            />
        </app-page-top-section>

        <app-table
                :options="options"
                id="faqs-table"
                @action="triggerActions"
        />

        <app-confirmation-modal
                v-if="confirmationModalActive"
                icon="trash-2"
                modal-id="app-confirmation-modal"
                @confirmed="confirmed('faqs-table')"
                @cancelled="cancelled"
        />

        <app-faq-create-edit
                v-if="isModalActive"
                v-model="isModalActive"
                :selected-url="selectedUrl"
        />
    </div>
</template>

<script>
    import FaqsMixin from "./Mixins/FaqsMixin";
    import HelperMixin from "../../../Mixins/HelperMixin";
    import TriggerActionMixin from "../../../Mixins/TriggerActionMixin";
    import DataTableHelperMixin from "../../../Mixins/DatatableHelperMixin";
    import {FAQS} from "../../../Config/ApiUrl";

    export default {
        name: "Faqs",
        mixins: [FaqsMixin, HelperMixin, TriggerActionMixin, DataTableHelperMixin],
        data() {
            return {
                selectedUrl: '',
                isModalActive: false,
                confirmationModalActive: false,
                delete_url: ''
            }
        },
        methods: {
            triggerActions(row, action, active) {
                if (action.name === 'edit') {
                    this.selectedUrl = `${FAQS}/${row.id}`;
                    this.isModalActive = true;
                } else {
                    const baseURL = `${action.url}/${row.id}`;
                    if (action.name === 'delete') {
                        this.delete_url = baseURL
                        this.confirmationModalActive = true;
                    }
                }
            },
            openAddModal() {
                this.isModalActive = true;
            }
        },
        watch: {
            isModalActive: function (isModalActive) {
                if (!isModalActive) {
                    this.selectedUrl = '';
                }
            }
        }
    }
</script>

<style scoped>

</style>